import { Download, ExternalLink } from "lucide-react";
import { useSeo } from "../lib/seo";
import { PROFILE, SPEAKING_TOPICS } from "../data/content";
import { PageIntro } from "../components/site/Sections";
import { SpeakingForm } from "../components/forms/SpeakingForm";

export default function Speaking() {
  useSeo("Speaking & training", "Invite Michelle Andros to speak or train: deaf education topics for conferences, universities, districts and family groups, in person or virtual.");
  return (
    <>
      <PageIntro eyebrow="Speaking & training" title="Invite Michelle to speak" testid="speaking-intro">
        <p>Guest lectures, conference sessions and staff trainings on topics related to deaf education, for conferences, universities, school districts and family groups. Live or virtual.</p>
        <div className="mt-6 flex flex-wrap items-center gap-4">
          <a href="#invite" className="inline-flex font-sans bg-teal text-paper rounded-full px-7 py-3.5 hover:bg-teal-deep transition-colors" data-testid="speaking-hero-cta">Send an invitation</a>
          <a href="/michelle-andros-speaker-sheet.pdf" download className="inline-flex items-center gap-2 font-sans border-2 border-teal text-teal rounded-full px-6 py-3 hover:bg-teal hover:text-paper transition-colors" data-testid="speaker-sheet-download">
            <Download className="w-4 h-4" aria-hidden="true" /> Download speaker sheet (PDF)
          </a>
        </div>
      </PageIntro>
      <section className="bg-cream text-ink pb-24" aria-labelledby="topics-title" data-testid="speaking-topics">
        <div className="max-w-6xl mx-auto px-6">
          <h2 id="topics-title" className="font-display">Talk topics</h2>
          <ol className="mt-10 grid md:grid-cols-2 gap-x-12">
            {SPEAKING_TOPICS.map((t, i) => (
              <li key={t.title} className="border-t border-ink/20 py-7 flex gap-6">
                <span className="font-display italic text-2xl text-brass w-10 shrink-0" aria-hidden="true">{String(i + 1).padStart(2, "0")}</span>
                <div><h3 className="font-display text-2xl">{t.title}</h3><p className="mt-2 text-slate">{t.text}</p>
                  {t.link && (
                    <a href={t.link.url} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 font-sans link-u text-teal" data-testid="speaking-visual-phonics-link">
                      {t.link.label} <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" /><span className="sr-only">(opens in a new tab)</span>
                    </a>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <section className="bg-sky text-ink py-24" aria-labelledby="past-title" data-testid="speaking-past">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_2fr] gap-12">
          <h2 id="past-title" className="font-display">Where Michelle has spoken</h2>
          <ul className="space-y-5">
            {PROFILE.talks.map((t) => (
              <li key={t.text} className="flex gap-5"><span className="font-sans text-sm text-teal font-semibold w-20 shrink-0 pt-1">{t.year}</span><span>{t.text}</span></li>
            ))}
          </ul>
        </div>
      </section>
      <section id="invite" className="scroll-mt-8 bg-cream text-ink py-24" aria-labelledby="invite-title" data-testid="speaking-invite">
        <div className="max-w-4xl mx-auto px-6">
          <h2 id="invite-title" className="font-display">Send an invitation</h2>
          <p className="mt-3 mb-10 text-slate">Share a few details about your event. Fields marked * are required.</p>
          <SpeakingForm />
        </div>
      </section>
    </>
  );
}
